// ============================================================================
// UKRAINIAN TRANSLATIONS - CHAPTER 1: БУТТЯ
// ============================================================================
// Рівні 1-13 (13 рівнів, 39 запитань)

export const chapter1Translations = {
  name: "Буття",
  description: "На початку… Знання оживляє дух",
  
  spiritualWisdom: {
    principle: "Знання оживляє дух",
    scripture: "Гине народ Мой через брак знання (Осія 4:6)",
    application: "Кожен вивчений вірш, кожна відкрита істина живить нашу душу та зміцнює нашу віру"
  },
  
  levels: {
    1: {
      name: "Створення",
      challenge: "На початку Бог створив небо і землю…",
      easy: {
        question: "За скільки днів Бог створив світ?",
        options: ["5 днів", "6 днів", "7 днів", "8 днів"],
        hint: "Подумайте про день відпочинку в тижні",
        funFact: "💡 На 7-й день Бог спочив від усіх Своїх діл. Це походження суботи, щотижневого дня відпочинку!"
      },
      medium: {
        question: "Що Бог створив на четвертий день?",
        options: ["Тварин", "Людину", "Сонце, місяць і зорі", "Рослини"],
        hint: "Ці творіння освітлюють землю та позначають час",
        funFact: "🌟 Світила були створені для знаків, часів, днів і років!"
      },
      hard: {
        question: "Що означає, що людина створена 'за образом Божим'?",
        options: [
          "Ідентична фізична зовнішність",
          "Здатність творити і любити",
          "Природне безсмертя",
          "Божественна сила"
        ],
        hint: "Мова йде про духовні та інтелектуальні якості",
        funFact: "✨ Образ Божий в нас включає творчі здібності, моральну свідомість і здатність любити!"
      }
    },
    
    2: {
      name: "Спокуса в саду",
      challenge: "Змій був найхитріший з усіх польових звірів…",
      easy: {
        question: "Яка тварина спокушала Єву в саду?",
        options: ["Лев", "Змій", "Орел", "Дракон"],
        hint: "Ця тварина повзає на животі",
        funFact: "🐍 Змій, можливо, мав ноги спочатку, але був прокльон повзати на животі!"
      },
      medium: {
        question: "Яка була перша реакція Адама і Єви після вкушення забороненого плоду?",
        options: [
          "Вони помолилися Богу",
          "Вони засоромилися і сховалися",
          "Вони з'їли ще",
          "Вони заснули"
        ],
        hint: "Вони усвідомили свою непокору",
        funFact: "👀 Відкрилися очі у них, і дізналися вони, що нагі!"
      },
      hard: {
        question: "Чого вчить нас ця історія про спокусу?",
        options: [
          "Спокуса неминуча і добра",
          "Непокора Богу призводить до духовної смерті",
          "Знання завжди небезпечне",
          "Бог створив людей, щоб вони грішили"
        ],
        hint: "Мова про покору та наслідки",
        funFact: "⚡ Відплата за гріх — смерть, але у Бога є план відновлення!"
      }
    },
    
    3: {
      name: "Каїн і Авель",
      challenge: "Де Авель, брат твій?",
      easy: {
        question: "Яка професія була у Каїна?",
        options: ["Пастух", "Землероб", "Рибалка", "Мисливець"],
        hint: "Він обробляв землю",
        funFact: "🌾 Каїн був землеробом, як його батько Адам!"
      },
      medium: {
        question: "Чому Бог не прийняв приношення Каїна?",
        options: [
          "Жертва була недостатньо великою",
          "Проблема була в його серці та мотивах",
          "Він прийшов занадто пізно",
          "Бог віддавав перевагу Авелю"
        ],
        hint: "Бог дивиться на серце, а не на зовнішнє",
        funFact: "💝 Бог дивиться не на обличчя, а на серце та ставлення!"
      },
      hard: {
        question: "Чого вчить нас ця історія про заздрість?",
        options: [
          "Заздрість природна",
          "Заздрість, якщо її не контролювати, веде до гріха",
          "Бог любить створювати конфлікти",
          "Заздрість робить сильнішими"
        ],
        hint: "Мова про контроль наших негативних емоцій",
        funFact: "🔥 Гріх лежить біля дверей, але ми повинні панувати над ним!"
      }
    },
    
    4: {
      name: "Потоп Ноя",
      challenge: "Зроби собі ковчег…",
      easy: {
        question: "Скільки пар кожної чистої тварини Ной взяв у ковчег?",
        options: ["1 пара", "2 пари", "7 пар", "10 пар"],
        hint: "Більше, ніж нечистих тварин",
        funFact: "🦁 Чистих тварин по 7 пар, нечистих по 2, для жертвопринесень і розмноження!"
      },
      medium: {
        question: "Скільки днів тривав потоп?",
        options: ["30 днів", "40 днів", "100 днів", "150 днів"],
        hint: "Це число в Біблії символізує випробування та очищення",
        funFact: "🌊 Дощ йшов 40 днів, але вода посилювалася 150 днів!"
      },
      hard: {
        question: "Що символізує веселка?",
        options: [
          "Погодне явище",
          "Знак завіту Бога з людством",
          "Гнів Божий",
          "Кінець потопу"
        ],
        hint: "Це знак вічної обіцянки Бога",
        funFact: "🌈 Веселка — знак завіту Бога ніколи більше не винищувати все живе потопом!"
      }
    },
    
    5: {
      name: "Вавилонська вежа",
      challenge: "Збудуймо собі місто і вежу…",
      easy: {
        question: "Що люди хотіли побудувати?",
        options: ["Палац", "Вежу заввишки до небес", "Міст", "Сад"],
        hint: "Вони хотіли досягти неба",
        funFact: "🏗️ Вавилонська вежа, ймовірно, була зіккуратом — ступінчастим храмом!"
      },
      medium: {
        question: "Як Бог зупинив будівництво Вавилонської вежі?",
        options: [
          "Він зруйнував вежу",
          "Він змішав їхню мову",
          "Він послав землетрус",
          "Він послав ангелів"
        ],
        hint: "Він зробив так, що вони не могли спілкуватися",
        funFact: "🗣️ 'Вавилон' означає 'змішання', бо там Бог змішав мови!"
      },
      hard: {
        question: "Чого вчить нас ця історія про гордість?",
        options: [
          "Амбіції завжди добрі",
          "Гордість і бажання бути як Бог веде до хаосу",
          "Єдність завжди від Бога",
          "Будувати високі вежі — гріх"
        ],
        hint: "Мова про людську гординю та Божий суверенітет",
        funFact: "⚡ Гордість передує падінню, і пиха перед крахом!"
      }
    },
    
    6: {
      name: "Покликання Авраама",
      challenge: "Йди з землі твоєї, від роду твого і з дому батька твого…",
      easy: {
        question: "Звідки Бог покликав Авраама піти?",
        options: ["Єгипет", "Ханаан", "Ур", "Вавилон"],
        hint: "Це було місто в Месопотамії",
        funFact: "🏛️ Ур був процвітаючим містом з ідолопоклонством!"
      },
      medium: {
        question: "Що Бог обіцяв Авраамові?",
        options: [
          "Багатство",
          "Великий народ, землю і потомство",
          "Довголіття",
          "Престол"
        ],
        hint: "Потрійна обіцянка: потомство, земля і благословення",
        funFact: "⭐ Бог обіцяв Авраамові потомство, як зорі на небі!"
      },
      hard: {
        question: "Чого вчить нас послух Авраама про віру?",
        options: [
          "Віра вимагає бачити всі відповіді",
          "Віра — це послух Богу, не знаючи кінцевого пункту",
          "Віра — це слабкість",
          "Послух необов'язковий"
        ],
        hint: "Мова про довіру і йдіння за Богом",
        funFact: "🚶 Авраам вийшов, не знаючи, куди йде, — це справжня віра!"
      }
    },
    
    7: {
      name: "Жертвопринесення Ісаака",
      challenge: "Бог усмотрить Собі агнця для всепалення…",
      easy: {
        question: "Кого Авраам мав принести в жертву?",
        options: ["Свого слугу", "Свого сина Ісаака", "Свою дружину", "Вівцю"],
        hint: "Його єдиний син, якого він любив",
        funFact: "💝 Ісаак був сином обітниці, народженим, коли Авраамові було 100 років!"
      },
      medium: {
        question: "Що в підсумку було принесено в жертву замість Ісаака?",
        options: [
          "Бик",
          "Агнець",
          "Баран, заплутаний рогами в хащах",
          "Нічого"
        ],
        hint: "Бог приготував замінну тварину",
        funFact: "🐏 Баран, заплутаний рогами, чудово прообразує жертву Христа!"
      },
      hard: {
        question: "Яку духовну істину передвіщає ця історія?",
        options: [
          "Бог радіє людським жертвам",
          "Бог надасть те, що Він вимагає",
          "Людські жертви угодні Богу",
          "Авраам насправді не любив Ісаака"
        ],
        hint: "Мова про довіру навіть тоді, коли ми не розуміємо",
        funFact: "💝 Коли ми довіряємо Богу, Він завжди передбачає вихід!"
      }
    },

    8: {
      name: "Яків і Ісав",
      challenge: "Більший буде служити меншому…",
      easy: {
        question: "За що Ісав продав своє первородство?",
        options: ["Золото", "Миску сочевичної юшки", "Одяг", "Вино"],
        hint: "Миска, щоб втамувати голод",
        funFact: "🍲 Хвилина голоду коштувала Ісаву вічного благословення!"
      },
      medium: {
        question: "Як Яків обманув свого батька Ісаака?",
        options: [
          "Змінив голос",
          "Переодягнувся",
          "Покрив себе козячими шкурами",
          "Збрехав про своє ім'я"
        ],
        hint: "Щоб бути схожим на волохатого брата",
        funFact: "🎭 Сліпий Ісаак впізнав запах і дотик, але не обман!"
      },
      hard: {
        question: "Що ця історія розкриває про наші вибори?",
        options: [
          "Обман іноді необхідний",
          "Миттєві бажання можуть коштувати нам долі",
          "Бог схвалює хитрість",
          "Молодший завжди переважний"
        ],
        hint: "Мова про наслідки наших імпульсивних рішень",
        funFact: "⚖️ Наші імпульсивні вибори можуть мати вічні наслідки!"
      }
    },

    9: {
      name: "Сон Якова",
      challenge: "Ось, драбина стоїть на землі, а верх її сягає неба…",
      easy: {
        question: "Що побачив Яків уві сні?",
        options: [
          "Гігантське дерево",
          "Драбину в небо з ангелами",
          "Храм",
          "Зорі"
        ],
        hint: "Засіб зв'язку між небом і землею",
        funFact: "👼 Драбина Якова символізує зв'язок між Небом і Землею!"
      },
      medium: {
        question: "Що зробив Яків з каменем, який служив йому узголів'ям?",
        options: [
          "Розбив його",
          "Закопав його",
          "Поставив його і полив на нього олію",
          "Взяв його з собою"
        ],
        hint: "Зробив з нього священний пам'ятник",
        funFact: "🪨 Цей камінь стає 'Ветілем' — домом Божим!"
      },
      hard: {
        question: "Як це видіння з'єднує небо і землю в нашому житті?",
        options: [
          "Тільки через сни",
          "Через молитву, яка встановлює міст до божественного",
          "Через ангелів-охоронців",
          "Через святі місця"
        ],
        hint: "Мова про наше спілкування з Богом",
        funFact: "🌉 Молитва — це наша особиста драбина в Небо!"
      }
    },

    10: {
      name: "Йосип, проданий братами",
      challenge: "Ось, іде сновидець…",
      easy: {
        question: "Скільки братів було у Йосипа?",
        options: ["7 братів", "10 братів", "11 братів", "12 братів"],
        hint: "На одного менше числа коліст Ізраїлевих",
        funFact: "👨‍👨‍👦‍👦 12 синів Якова стануть 12 колінами Ізраїля!"
      },
      medium: {
        question: "За скільки срібників був проданий Йосип?",
        options: [
          "10 срібників",
          "20 срібників",
          "30 срібників",
          "50 срібників"
        ],
        hint: "Ціна раба",
        funFact: "💰 20 срібників — ціна раба в той час!"
      },
      hard: {
        question: "Як заздрість перетворюється на інструмент Божого плану?",
        options: [
          "Бог схвалює заздрість",
          "Вчинене зло перетворюється Богом на добро",
          "Заздрість необхідна",
          "Брати були праві"
        ],
        hint: "Мова про Боже провидіння, що перетворює зло на добро",
        funFact: "🎨 Бог перетворює навіть наші найгірші вчинки на шедевр благодаті!"
      }
    },

    11: {
      name: "Йосип у в'язниці",
      challenge: "Господь був з Йосипом і простяг до нього милість…",
      easy: {
        question: "Який особливий дар був у Йосипа?",
        options: [
          "Пророкувати",
          "Тлумачити сни",
          "Зціляти хворих",
          "Розмовляти з тваринами"
        ],
        hint: "Здатність, пов'язана зі снами",
        funFact: "💭 Сни вважалися божественними посланнями в стародавньому світі!"
      },
      medium: {
        question: "Які слуги фараона були у в'язниці з Йосипом?",
        options: [
          "Візир і писар",
          "Чашник і хлібодар",
          "Лікар і сторожа",
          "Кухар і садівник"
        ],
        hint: "Той, хто подавав вино, і той, хто подавав хліб",
        funFact: "🍷 Чашник куштував вино царя, щоб запобігти отруєнню!"
      },
      hard: {
        question: "Чого вчить нас Йосип про вірність у негараздах?",
        options: [
          "Несправедливість прийнятна",
          "Вірність Богу перевершує обставини",
          "В'язниця змінює людей",
          "Потрібно мститися"
        ],
        hint: "Мова про збереження вірності навіть у випробуваннях",
        funFact: "⭐ Навіть у в'язниці Йосип залишався праведним, і Бог возвисив його!"
      }
    },

    12: {
      name: "Сни фараона",
      challenge: "Сім корів ситих… сім корів худих…",
      easy: {
        question: "Скільки худих корів пожерли ситих корів?",
        options: ["5", "6", "7", "8"],
        hint: "Досконале число",
        funFact: "🐄 Число 7 символізує досконалість і повноту в Біблії!"
      },
      medium: {
        question: "Що означали 7 років у сні?",
        options: [
          "7 років війни, потім мир",
          "7 років достатку, потім 7 років голоду",
          "7 років хвороби, потім здоров'я",
          "7 років дощу, потім посуха"
        ],
        hint: "Цикл достатку та нестачі",
        funFact: "🌾 Йосип врятував Єгипет і свою сім'ю завдяки цьому тлумаченню!"
      },
      hard: {
        question: "Як Божа мудрість перетворює кризи?",
        options: [
          "Уникаючи всіх криз",
          "Даючи передбачення для підготовки",
          "Караючи нечестивих",
          "Збагачуючи віруючих"
        ],
        hint: "Мова про підготовку та передбачення",
        funFact: "💡 Божа мудрість перетворює кризи на можливості спасіння!"
      }
    },

    13: {
      name: "Примирення братів",
      challenge: "Я Йосип, брат ваш, якого ви продали…",
      easy: {
        question: "Що поклав Йосип у мішок Веніаміна?",
        options: [
          "Золото",
          "Свій перстень",
          "Свою срібну чашу",
          "Лист"
        ],
        hint: "Дорогоцінна особиста річ",
        funFact: "🏆 Чаша також використовувалася для 'ворожіння' по воді!"
      },
      medium: {
        question: "Яку знамениту фразу сказав Йосип про перетворення зла на добро?",
        options: [
          "Я прощаю вас",
          "Ви мислили проти мене зло, але Бог обернув це на добро",
          "Забудьмо минуле",
          "Мені помста, Я воздам"
        ],
        hint: "Фраза про Боже провидіння",
        funFact: "✨ Ця фраза резюмує все Боже провидіння в нашому житті!"
      },
      hard: {
        question: "Як прощення розриває цикли помсти?",
        options: [
          "Забуваючи зло",
          "Звільняючи кривдника і скривдженого для нового початку",
          "Спочатку покаравши",
          "Зберігаючи дистанцію"
        ],
        hint: "Мова про взаємне звільнення",
        funFact: "🕊️ Прощення Йосипа передвіщає всесвітнє Боже прощення!"
      }
    }
  }
};

export default chapter1Translations;
